import React from 'react';
import { Card } from './ui/Card';
import { Gamepad2, Layers, Wifi, Cpu, Sparkles, LayoutDashboard, Plus } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from '../i18n/translations';
export function ServicesSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].services;
  const services = [{
    title: t.items.gameplay.title,
    icon: <Gamepad2 className="w-8 h-8 text-[#00f5a0]" data-id="element-217" />,
    description: t.items.gameplay.description,
    features: t.items.gameplay.features,
    accent: '#00f5a0',
    isExtra: false
  }, {
    title: t.items.ui.title,
    icon: <LayoutDashboard className="w-8 h-8 text-[#00c9a7]" data-id="element-218" />,
    description: t.items.ui.description,
    features: t.items.ui.features,
    accent: '#00c9a7',
    isExtra: false
  }, {
    title: t.items.multiplayer.title,
    icon: <Wifi className="w-8 h-8 text-[#1a4fd6]" data-id="element-219" />,
    description: t.items.multiplayer.description,
    features: t.items.multiplayer.features,
    accent: '#1a4fd6',
    isExtra: false
  }, {
    title: t.items.integration.title,
    icon: <Layers className="w-8 h-8 text-[#00c9a7]" data-id="element-220" />,
    description: t.items.integration.description,
    features: t.items.integration.features,
    accent: '#00c9a7',
    isExtra: false
  }, {
    title: t.items.ai.title,
    icon: <Cpu className="w-8 h-8 text-[#00f5a0]" data-id="element-221" />,
    description: t.items.ai.description,
    features: t.items.ai.features,
    accent: '#00f5a0',
    isExtra: false
  }, {
    title: t.items.polish.title,
    icon: <Sparkles className="w-8 h-8 text-[#1a4fd6]" data-id="element-222" />,
    description: t.items.polish.description,
    features: t.items.polish.features,
    accent: '#1a4fd6',
    isExtra: false
  }, {
    title: t.items.more.title,
    icon: <Plus className="w-8 h-8 text-[#00c9a7]" data-id="element-223" />,
    description: t.items.more.description,
    features: t.items.more.features,
    accent: '#00c9a7',
    isExtra: true
  }];
  return <section id="services" className="py-24 bg-[#080816]" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="text-center mb-16" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-227">{t.title}</h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-228">{t.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-229">
          {services.map((service, index) => service.isExtra /* Centered extra card: spans 2 cols on md, 1 col centered on lg */ ? <div key={index} className="md:col-span-2 lg:col-span-1 lg:col-start-2 rounded-xl border-2 border-dashed border-white/10 flex flex-col items-center justify-center p-8 text-center group hover:border-[#00c9a7]/30 transition-all duration-500 min-h-[280px]" data-id="element-230">
                <div className="mb-5 p-3 rounded-lg w-fit border border-dashed border-white/10 bg-white/3 group-hover:border-[#00c9a7]/30 transition-colors" data-id="element-231">
                  <Plus className="w-8 h-8 text-white/20 group-hover:text-[#00c9a7]/60 transition-colors" data-id="element-232" />
                </div>
                <h3 className="text-lg font-bold mb-3 text-white/40 group-hover:text-white/70 transition-colors" data-id="element-233">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-5 group-hover:text-gray-400 transition-colors" data-id="element-234">
                  {service.description}
                </p>
                <ul className="space-y-2" data-id="element-235">
                  {service.features.map((feature, idx) => <li key={idx} className="flex items-center justify-center text-xs text-gray-600 group-hover:text-gray-500 transition-colors" data-id="element-236">
                      <span className="w-1.5 h-1.5 rounded-full mr-2 flex-shrink-0 bg-white/10 group-hover:bg-[#00c9a7]/40 transition-colors" data-id="element-237"></span>
                      {feature}
                    </li>)}
                </ul>
              </div> : <Card key={index} className="flex flex-col h-full group" data-id="element-238">
                <div className="mb-5 p-3 rounded-lg w-fit border border-white/10 bg-white/5" style={{
            boxShadow: `0 0 20px ${service.accent}20`
          }} data-id="element-239">
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold mb-3 group-hover:text-gradient transition-colors" data-id="element-240">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-sm mb-5 flex-grow leading-relaxed" data-id="element-241">
                  {service.description}
                </p>
                <ul className="space-y-2 mt-auto" data-id="element-242">
                  {service.features.map((feature, idx) => <li key={idx} className="flex items-center text-xs text-gray-400" data-id="element-243">
                      <span className="w-1.5 h-1.5 rounded-full mr-2 flex-shrink-0" style={{
                backgroundColor: service.accent
              }} data-id="element-244"></span>
                      {feature}
                    </li>)}
                  <li className="flex items-center text-xs text-gray-600 italic" data-id="element-245">
                    <span className="w-1.5 h-1.5 rounded-full mr-2 flex-shrink-0 bg-white/15" data-id="element-246"></span>
                    {t.andMore}
                  </li>
                </ul>
              </Card>)}
        </div>
      </div>
    </section>;
}